import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { WingViewComponentInterface, WingViewModelInterface } from "@nts/std/interfaces";

@UntilDestroy()
@Component({
    template: '',
    standalone: true,
})
export class BaseWingComponent implements WingViewComponentInterface, OnInit {
    wingViewModel: WingViewModelInterface;

    constructor(protected readonly cd: ChangeDetectorRef) { }

    ngOnInit(): void { }

    async initialize(): Promise<void> {
        this.wingViewModel.wingInfoChanged.pipe(untilDestroyed(this)).subscribe((wingInfo) => {
            this.cd.detectChanges();
        });

        this.wingViewModel.orchestratorViewModel.eventDispatcher.onWingCollapsed
            .pipe(
                untilDestroyed(this)
            )
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            .subscribe(async (isCollapsed) => {
                await this.onWingCollapsedChanged(isCollapsed);

                this.cd.detectChanges();
            });

        return Promise.resolve();
    }

    async onWingCollapsedChanged(isCollapsed: boolean): Promise<void> { }
}
